





































import {Component, Prop, Watch} from 'vue-property-decorator';
import BaseComponent from '@/core/components/BaseComponent';
import {Measurement} from "@/core/services/MedicaPro/models";
import bus from "@/main";
import DateView from "@/components/Shared/DateView.vue";

@Component({
    components: {DateView}
})
export default class ClientMeasurementListRow extends BaseComponent {

    // Bindings to parent
    @Prop() item!: Measurement;

    // Bindings to view
    public isReady = false;
    public name = '';
    public value = -1;
    public color: 'green' | 'orange' | 'red' = 'green';

    public mounted() {
        this.renderView();
    }

    public beforeDestroy() {
        super.beforeDestroy();
    }

    @Watch('item')
    private renderView() {
        this.name = this.item.measurement_type_identifier ?? '';
        this.value = this.item.value_override ?? this.item.value ?? -1;
        if (this.value > 16) {
            this.color = 'red';
        } else if (this.value > 8) {
            this.color = 'orange';
        } else {
            this.color = 'green';
        }
        this.isReady = true;
    }

    public onClick() {
        bus.$emit('filterByMeasurementIdentifier', this.item.category, this.item.measurement_type_identifier);
    }

}
